// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"d2e3e47f","285":"72bc452a","330":"7c89a129","587":"cf6d0092","824":"47ce1d2a","953":"f7a077a9"}[chunkId] + ".chunk.js";
};